import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";

const HomeNav = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  
  // Get current route to determine navbar color
  const location = useLocation();
  const isHome = location.pathname === "/";

  // Optional UX: Make the navbar blue if the user scrolls down on the home page
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  // Dynamic background based on route and scroll
  const navBackground =
    isHome && !scrolled && !isOpen
      ? "transparent"
      : "linear-gradient(135deg, #0369a1 0%, #1e40af 100%)";

  const navLinkStyle = {
    color: "#ffffff",
    textDecoration: "none",
    fontSize: "0.95rem",
    fontWeight: "500",
    padding: "8px 12px",
    borderRadius: "6px",
    transition: "all 0.2s ease-in-out",
  };

  return (
    <header
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        transition: "background 0.3s ease-in-out",
      }}
    >
      <nav
        style={{
          background: navBackground,
          boxShadow: scrolled || !isHome ? "0 4px 12px rgba(0, 0, 0, 0.15)" : "none",
          padding: "12px 24px",
          transition: "all 0.3s ease-in-out",
        }}
      >
        <div
          style={{
            maxWidth: "1100px",
            margin: "0 auto",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Link
            to="/"
            onClick={closeMenu}
            style={{
              color: "#ffffff",
              fontSize: "1.35rem",
              fontWeight: "800",
              textDecoration: "none",
              letterSpacing: "-0.025em",
            }}
          >
            JKUSDA
          </Link>

          {/* Desktop Nav */}
          <div
            className="desktop-nav"
            style={{ display: "flex", alignItems: "center", gap: "16px" }}
          >
            <Link to="/" style={navLinkStyle}>Home</Link>
            <Link to="/tickets" style={navLinkStyle}>Tickets</Link>
            <Link
              to="/Login"
              style={{ ...navLinkStyle, border: "1px solid rgba(255, 255, 255, 0.3)" }}
            >
              Login
            </Link>
            <Link
              to="/Register"
              style={{ ...navLinkStyle, backgroundColor: "#ffffff", color: "#0284c7", fontWeight: "600" }}
            >
              Register
            </Link>
          </div>

          {/* Mobile Toggler */}
          <button
            type="button"
            onClick={toggleMenu}
            className="mobile-toggler"
            style={{
              display: "none",
              background: "transparent",
              border: "none",
              cursor: "pointer",
              color: "#ffffff",
              padding: "4px",
            }}
          >
            {isOpen ? <CloseIcon sx={{ fontSize: 28 }} /> : <MenuIcon sx={{ fontSize: 28 }} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              paddingTop: "16px",
              paddingBottom: "8px",
              borderTop: "1px solid rgba(255, 255, 255, 0.15)",
              marginTop: "12px",
            }}
          >
            <Link to="/" onClick={closeMenu} style={navLinkStyle}>Home</Link>
            <Link to="/tickets" onClick={closeMenu} style={navLinkStyle}>Tickets</Link>
            <Link to="/Login" onClick={closeMenu} style={navLinkStyle}>Login</Link>
            <Link
              to="/Register"
              onClick={closeMenu}
              style={{ ...navLinkStyle, backgroundColor: "#ffffff", color: "#0284c7", textAlign: "center", fontWeight: "600" }}
            >
              Register
            </Link>
          </div>
        )}
      </nav>

      <style>{`
        @media (max-width: 768px) {
          .desktop-nav { display: none !important; }
          .mobile-toggler { display: block !important; }
        }
      `}</style>
    </header>
  );
};

export default HomeNav;